/**
 * Update date: 12-05-2023
 * Screen 1043.1
 */

import PopupConfirm from 'app/components/PopupCommon/PopupConfirm';
import PopupSelectStore from 'app/components/PopupCommon/PopupSelectStore';
import PopupSelectVendor from 'app/components/PopupCommon/PopupSelectVendor';
import useAxios from 'axios-hooks';
import { CONSTANT, ROLE_TYPE } from 'constant';
import { Button, Form } from 'devextreme-react';
import LoadPanel from 'app/components/LoadPanel';
import { uniq } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { notification } from 'utils/notification';
import { valid } from 'utils/validation';
import { useRegistration } from '..';
import TreeViewSelection from './TreeViewSelection';
import useDictionary from 'hooks/useDictionary';
import { restrictKeyboardPhone } from 'utils/common/restrict-keyboard-phone';
import PopupSelectCommonCode from 'app/components/PopupCommon/PopupSelectCommonCode';
import { useApp } from 'app';
import { BreadCrumbPremium } from 'app/components/BreadCrumbPremium';
import { cloneDeep, uniqBy } from 'lodash';
var rexEmail =
  /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFFu20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-\.\d]+)((\.([a-zA-Z\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF]){2,63})+)$/i;
const eye = 'fas fa-eye';
const eyeSlash = 'fas fa-eye-slash';
const vendorStore = [1, 2];

interface IOptionItem {
  isRequired?: boolean;
  colSpan?: number;
  readOnly?: boolean;
}

const FormCreate = props => {
  const { themePro }: any = useApp();
  const context: any = useRegistration();
  const formRef: any = useRef(null);
  const { listPhone } = CONSTANT;
  const { regexPassword } = valid;
  const { modeView, setModeView, itemSelected, onUpdateData } = context;
  const [idSelected, setIdSelected] = useState([]);
  const [showPopupByType, setShowPopupByType] = useState('');
  const [showModalConfirm, setShowModalConfirm] = useState<any>(false);
  const [contentPopupConfirm, setContentPopupConfirm] = useState('');
  const [elementSwitch, setElementSwitch] = useState<any>(null);
  const [formData, setFormData] = useState<any>({
    userId: null,
    email: '',
    name: '',
    password: '',
    confirmPassword: '',
    phone: '',
    mobile: '',
    roleType: '',
    company: '',
    programIds: [],
    status: false,
    note: '',
    loginId: '',
    clientId: 0,
    vendorOrStore: '',
    mobileCode: '',
    phoneCode: '',
    productType: '',
    formStore: {
      vendorOrStore: null,
      productType: [],
    },
  });
  const treeViewLeftRef: any = useRef(null);
  const treeViewRightRef: any = useRef(null);
  const [viewPassword, setViewPassword] = useState({
    password: false,
    conPassword: false,
  });
  const { t }: any = useDictionary({
    programId: '1043.1',
  });
  const isRequired = modeView?.type === 'create' ? true : false;
  const [{ loading }, refetchData] = useAxios(
    {
      method: 'GET',
    },
    { manual: true, autoCancel: true },
  );
  const [{ loading: loadingDuplication }, refetchDuplication] = useAxios(
    {
      method: 'GET',
    },
    { manual: true, autoCancel: true },
  );
  const [{ loading: loadingUpdate }, refetchUpdate] = useAxios(
    {
      url: '/user/user',
      method: 'PUT',
    },
    { manual: true, autoCancel: true },
  );
  const [{ loading: loadingCommonDB }, refetchCommonDB] = useAxios(
    {
      url: '/core/common-code/type',
      data: { codeName: '', codeType: 'DB', parentCd: '' },
      method: 'POST',
    },
    { useCache: false, autoCancel: true },
  );
  const [{ loading: loadingGetDashboard }, refetchGetDashboard] = useAxios(
    {
      url: '/user/chart/user-dash-board',
      method: 'POST',
    },
    { manual: true, autoCancel: true },
  );
  const [{ loading: loadingPostDashboard }, refetchDashboardUpdate] = useAxios(
    {
      url: '/user/chart/save-user-dash-board',
      method: 'POST',
    },
    { manual: true, autoCancel: true },
  );
  /**
   * on check duplicate
   *
   */
  const handleCheckDuplicate = async () => {
    const res = await refetchDuplication({
      url: 'user/user/check-loginId-exist',
      params: {
        loginId: formData?.loginId,
        userId: formData?.userId,
      },
    });
    notification({ res });
  };
  /**
   * on submit
   *
   * @param {*} { type }
   */
  const submitData = async ({ type }) => {
    const programIds = themePro
      ? uniq([...treeViewLeftRef?.current?.instance?.getSelectedNodeKeys()])
      : uniq([
          ...treeViewLeftRef?.current?.instance?.getSelectedNodeKeys(),
          ...treeViewRightRef?.current?.instance?.getSelectedNodeKeys(),
        ]);
    const dataReq = {
      ...formData,
      status: formData?.status === false ? 1 : 2,
      phone: formData?.phoneCode + formData?.phone,
      mobile: formData?.mobileCode + formData?.mobile,
      programIds,
      roleType: ROLE_TYPE[itemSelected]?.value,
      clientId: formData?.formStore?.vendorOrStore?.id,
      productTp:
        formData?.formStore?.productType?.map(o => o?.code).join(',') || null,
    };
    if (!vendorStore.includes(itemSelected)) {
      delete dataReq.clientId;
      delete dataReq.company;
    }
    if (!formData?.mobile) {
      delete dataReq.mobile;
    }
    delete dataReq.confirmPassword;
    delete dataReq.formStore;
    delete dataReq.mobileCode;
    delete dataReq.phoneCode;
    delete dataReq.vendorOrStore;
    delete dataReq.bashboard;
    const res = await refetchUpdate({
      data: dataReq,
    });
    if (res?.data?.status === '201') {
      const resDashboard = await refetchDashboardUpdate({
        data: {
          userId: res?.data?.data?.userId || formData?.userId,
          dashBoards: formData?.formStore?.dashboard
            ?.map(o => o?.code)
            .join(', '),
        },
      });
      notification({
        res: resDashboard,
      });
      onUpdateData({ data: res?.data?.data, type });
    } else {
      notification({ res });
    }
  };
  /**
   * on validate
   *
   * @return {*}
   */
  const handleSubmit = async () => {
    const isValid = formRef?.current?.instance?.validate()?.isValid;
    if (!isValid) return;
    submitData({ type: 'list' });
  };
  /**
   * update data list from type
   *
   * @param {*} data
   */
  const updateStore = data => {
    const index = 5;
    let newFormData = {};
    if (modeView?.type === 'create') {
      if (itemSelected === 2) {
        const mobileCode = data?.vendorMobile?.slice?.(0, index) || '';
        const mobile =
          data?.vendorMobile?.slice?.(index, data?.vendorMobile?.length) || '';
        const phoneCode = data?.vendorPhone?.slice?.(0, index) || '';
        const phone =
          data?.vendorPhone?.slice?.(index, data?.vendorPhone?.length) || '';
        newFormData = {
          name: data?.vendorName,
          email: data?.vendorEmail,
          loginId: data?.vendorEmail,
          phoneCode,
          phone,
          mobileCode,
          mobile,
          company: data?.vendorName,
        };
      } else {
        const mobileCode = data?.mobile?.slice?.(0, index) || '';
        const mobile = data?.mobile?.slice?.(index, data?.mobile?.length) || '';
        const phoneCode = data?.phone?.slice?.(0, index) || '';
        const phone = data?.phone?.slice?.(index, data?.phone?.length) || '';
        newFormData = {
          name: data?.storeNm,
          email: data?.email,
          loginId: data?.email,
          phoneCode,
          phone,
          mobileCode,
          mobile,
          company: data?.storeNm,
        };
      }
    }

    const formStore = {
      vendorOrStore:
        itemSelected === 2
          ? {
              id: data?.vendorId,
              name: data?.vendorName,
            }
          : {
              id: data?.storeNo,
              name: data?.storeNm,
            },
    };
    setFormData(preState => ({
      ...preState,
      ...newFormData,
      vendorOrStore: '',
      formStore,
    }));
    setShowPopupByType('');
  };
  /**
   * remove data list from type
   *
   */
  const removeStore = () => {
    setFormData(preState => ({
      ...preState,
      formStore: { vendorOrStore: null },
    }));
  };
  /**
   * remove store dashboard
   *
   * @param {*} popupType
   * @param {*} index
   */
  const removeStoreDashboard = (popupType, index) => {
    let newStore;
    if (index === -1) {
      setFormData(preState => ({
        ...preState,
        formStore: {
          ...preState?.formStore,
          [popupType]: [],
        },
      }));
    } else {
      const l = [...formData?.formStore[popupType]];
      newStore = [...l.slice(0, index), ...l.slice(index + 1)];
      setFormData(preState => ({
        ...preState,
        formStore: {
          ...preState?.formStore,
          [popupType]: newStore,
        },
      }));
    }
  };
  /**
   * update store dashboard
   *
   * @param {*} data
   */
  const updateDashboard = data => {
    setFormData(preState => ({
      ...preState,
      dashboard: '',
      formStore: {
        ...preState?.formStore,
        dashboard: data,
      },
    }));
    setShowPopupByType('');
  };

  /**
   * remove popup data
   *
   * @param {string} storedType
   * @param {number} index
   */
  const removePopupData = (storedType: string, index: number) => {
    const formStore = cloneDeep(formData?.formStore || {});
    if (index === -1) {
      formStore[storedType] = [];
    } else {
      formStore[storedType]?.splice(index, 1);
    }
    setFormData({
      ...formData,
      formStore: formStore,
    });
  };

  /**
   * update popup data
   *
   * @param {string} storedType
   * @param {*} data
   * @param {*} [key=false]
   */
  const updatePopupData = (storedType: string, data, key: any = false) => {
    const formStore = cloneDeep(formData?.formStore || {});
    let filterData: any = [data];
    if (key) {
      filterData = uniqBy([...(formStore?.[storedType] || []), ...data], key);
    }
    formStore[storedType] = filterData;
    const newData = {
      ...formData,
      formStore: formStore,
      [storedType]: '',
    };
    setFormData(newData);
    setShowPopupByType('');
  };

  /**
   * generate dx textbox
   *
   * @param {string} fieldLabel
   * @param {string} fieldName
   * @param {string} fieldBtnText
   * @param {IOptionItem} [option]
   * @param {number} [numberShowMore=2]
   * @return {*}  {*}
   */
  const generateDxTextBox = (
    fieldLabel: string,
    fieldName: string,
    fieldBtnText: string,
    option?: IOptionItem,
    numberShowMore = 2,
  ): any => {
    const dataList = formData?.formStore?.[fieldName] || [];
    const buttons = dataList.slice(0, numberShowMore).map((data, index) => {
      return {
        name: `${fieldName}${index}`,
        location: 'before',
        options: {
          icon: 'close',
          text: data?.[fieldBtnText],
          onClick: () => removePopupData(fieldName, index),
        },
      };
    });
    if (dataList.length > numberShowMore) {
      buttons.push({
        name: `${fieldName}More`,
        location: 'before',
        options: {
          text: `+ ${dataList.length - numberShowMore} ${t('more')}`,
        },
      });
    }
    if (dataList.length > 0) {
      buttons.push({
        name: 'clearAll',
        location: 'after',
        options: {
          stylingMode: 'text',
          icon: 'close',
          onClick: () => removePopupData(fieldName, -1),
        },
      });
    }
    buttons.push({
      name: 'search',
      location: 'after',
      options: {
        stylingMode: 'text',
        icon: 'search',
        onClick: () => setShowPopupByType(fieldName),
      },
    });
    return {
      label: { text: t(fieldLabel) },
      dataField: fieldName,
      editorType: 'dxTextBox',
      colSpan: option?.colSpan || 0,
      isRequired: option?.isRequired && !dataList.length,
      editorOptions: {
        readOnly: option?.readOnly || false,
        onEnterKey: () => setShowPopupByType(fieldName),
        showClearButton: true,
        buttons: buttons,
      },
    };
  };
  /**
   * poup by type
   *
   * @param {string} popupType
   * @return {*}
   */
  const getPopupByType = (popupType: string) => {
    switch (popupType) {
      case 'vendor':
        return (
          <PopupSelectVendor
            text={formData?.vendorOrStore}
            mode="single"
            visible={popupType === 'vendor'}
            onHiding={() => setShowPopupByType('')}
            onSubmit={updateStore}
          />
        );
      case 'store':
        return (
          <PopupSelectStore
            text={formData?.vendorOrStore}
            mode="single"
            visible={popupType === 'store'}
            onHiding={() => setShowPopupByType('')}
            onSubmit={updateStore}
          />
        );
      case 'dashboard':
        return (
          <PopupSelectCommonCode
            visible={popupType === 'dashboard'}
            text={formData?.dashboard}
            codeType="DB"
            mode="multiple"
            onHiding={() => setShowPopupByType('')}
            onSubmit={updateDashboard}
          />
        );
      case 'productType':
        return (
          <PopupSelectCommonCode
            text={formData?.productType}
            mode="multiple"
            codeType="PT"
            visible={showPopupByType === popupType}
            onHiding={() => setShowPopupByType('')}
            onSubmit={o => updatePopupData('productType', o, 'code')}
          />
        );
      default:
        return null;
    }
  };

  /**
   * validate password
   *
   * @param {*} o
   * @return {*}
   */
  const passwordRequired: any = o => {
    return {
      type: 'custom',
      validationCallback: (e: any) => {
        const { value } = e;
        if (modeView?.type === 'create' && !value) {
          return false;
        } else if (o && !value) {
          return false;
        } else {
          return true;
        }
      },
      message: t('Password is required'),
    };
  };
  /**
   * password match
   *
   * @type {*} */
  const passwordMatch: any = {
    type: 'custom',
    validationCallback: (e: any) => {
      if (!e?.value) return true;
      const { value } = e;
      if (formData?.password === value) return true;
      return false;
    },
    message: t('The password does not match'),
  };
  /**
   * validate mobile phone
   *
   * @param {*} name
   * @return {*}
   */
  const mobileRequired: any = name => {
    return {
      type: 'custom',
      validationCallback: e => {
        const { value } = e;
        if (modeView?.type === 'create' && !value) {
          return false;
        } else {
          return true;
        }
      },
      message: `${t('{0} is required')}`.replace('{0}', name),
    };
  };

  /**
   * validate email
   *
   * @param {*} e
   * @return {*}
   */
  const validateEmail = (e: any) => {
    const { value = null } = e;
    if (!value) return true;
    if (rexEmail.test(value)) return true;
    return false;
  };
  const filedCompanyName: any = () => {
    return vendorStore.includes(itemSelected)
      ? {
          dataField: 'company',
          editorType: 'dxTextBox',
          label: {
            text: t('Company Name'),
          },
          isRequired: true,
        }
      : {
          itemType: 'empty',
          visible: false,
        };
  };
  const filedVendor: any = () => {
    return vendorStore.includes(itemSelected)
      ? {
          dataField: 'vendorOrStore',
          editorType: 'dxTextBox',
          label: {
            text:
              itemSelected === 2
                ? t('Vendor')
                : itemSelected === 1
                ? t('Store')
                : '',
          },
          editorOptions: {
            onEnterKey: () =>
              setShowPopupByType(itemSelected === 2 ? 'vendor' : 'store'),
            showClearButton: true,
            buttons: [
              {
                name: 'label',
                location: 'before',
                options: {
                  icon: 'close',
                  text: formData?.formStore?.vendorOrStore?.name,
                  onClick: () => removeStore(),
                  visible: !!formData?.formStore?.vendorOrStore,
                  rtlEnabled: true,
                },
              },
              {
                name: 'search',
                location: 'after',
                options: {
                  stylingMode: 'text',
                  icon: 'search',
                  onClick: () =>
                    setShowPopupByType(itemSelected === 2 ? 'vendor' : 'store'),
                },
              },
            ],
          },
          isRequired: !formData?.formStore?.vendorOrStore?.id,
        }
      : {
          itemType: 'empty',
          visible: false,
        };
  };
  /**
   * on confirm
   *
   */
  const handleConfirm = async () => {
    submitData({ type: 'edit' });
    setShowModalConfirm(false);
    setElementSwitch(null);
  };
  /**
   * on approve
   *
   * @param {*} e
   */
  const handleApprove = e => {
    if (formData?.userId) {
      setShowModalConfirm(true);
      setElementSwitch(e?.previousValue);
      setContentPopupConfirm(
        `${t('Are you sure you want to')} ${
          e?.previousValue ? t('disapprove') : t('approve')
        } the ${t('"{0}"')}`.replace('{0}', formData?.name),
      );
    }
  };
  /**
   * on close
   *
   */
  const handleClose = () => {
    formRef?.current?.instance.updateData('status', elementSwitch);
    setShowModalConfirm(false);
    setElementSwitch(null);
  };
  /**
   * fetch data
   */
  useEffect(() => {
    if (modeView?.type === 'edit') {
      const fetchData = async () => {
        const res = await refetchData({
          url: `user/user/${modeView?.id}`,
        });
        const { data } = res?.data;
        let resDashboard: any = {};
        let resCommonDb: any = [];
        try {
          resDashboard = await refetchGetDashboard({
            data: {
              userId: data?.userId,
            },
          });
          resCommonDb = await refetchCommonDB({});
        } catch (error) {}
        const dbRes = (resDashboard?.data?.data || '').split(', ');
        const dataBD = resCommonDb?.data?.data || [];
        const dashboard = dataBD.filter(o => dbRes.some(s => s === o?.code));
        const isVendorOrStore = vendorStore.includes(itemSelected);
        const index = 5;
        const mobileCode = data?.mobile?.slice(0, index) || '';
        const mobile = data?.mobile?.slice(index, data?.mobile?.length) || '';

        const phoneCode = data?.phone?.slice(0, index) || '';
        const phone = data?.phone?.slice(index, data?.phone?.length) || '';

        const company = isVendorOrStore ? data?.companyName : '';
        const formStore = {
          vendorOrStore:
            isVendorOrStore && data?.clientId && data?.clientName
              ? {
                  id: data?.clientId,
                  name: data?.clientName,
                }
              : null,
          dashboard,
          productType: data?.productTypes || [],
        };

        let idSelected: any = [];

        data?.programIdResponses?.forEach((o: any) => {
          idSelected.push(o?.programId);
        });
        const dataForm: any = {
          userId: data?.userId,
          name: data?.name,
          email: data?.email,
          loginId: data?.loginId,
          note: data?.note,
          status: data?.status == 2 ? true : false,
          mobileCode,
          phoneCode,
          mobile,
          phone,
          company,
          formStore,
        };
        setFormData(dataForm);
        setIdSelected(idSelected);
      };
      fetchData();
    }
  }, [modeView?.type]);

  const passwordValid = {
    type: 'custom',
    validationCallback: (e: any) => {
      const { value } = e;
      if (!value) return true;
      return regexPassword(value);
    },
    message: t(
      'The password must contain at least 8 characters including number, letter, special character',
    ),
  };
  /**
   * render
   */
  return (
    <div>
      <LoadPanel
        visible={
          loading ||
          loadingDuplication ||
          loadingUpdate ||
          loadingPostDashboard ||
          loadingCommonDB ||
          loadingGetDashboard
        }
      />
      <BreadCrumbPremium
        onSubmit={handleSubmit}
        onCancel={() => setModeView({ type: 'list' })}
      />
      {themePro ? (
        <div style={{ display: 'flex', gap: 20 }}>
          <div
            style={{
              padding: 20,
              backgroundColor: '#fff',
              borderRadius: 6,
              width: 'calc(100% - 420px)',
            }}
          >
            <Form
              formData={formData}
              ref={formRef}
              showColonAfterLabel={false}
              className="bg-white"
              items={[
                {
                  dataField: 'userId',
                  editorType: 'dxTextBox',
                  label: {
                    text: t('ID'),
                  },
                  editorOptions: {
                    disabled: true,
                  },
                },
                filedVendor(),
                {
                  dataField: 'name',
                  editorType: 'dxTextBox',
                  label: {
                    text: t('User Name'),
                  },
                  isRequired: true,
                  validationRules: [
                    {
                      type: 'stringLength',
                      max: 100,
                    },
                  ],
                },
                {
                  dataField: 'email',
                  editorType: 'dxTextBox',
                  label: {
                    text: t('E-mail'),
                  },
                  // editorOptions: {
                  //   mode: 'email',
                  // },
                  validationRules: [
                    {
                      type: 'required',
                    },
                    {
                      type: 'custom',
                      validationCallback: validateEmail,
                      message: t('Email is invalid'),
                    },
                  ],
                },
                ![1, 2].includes(itemSelected)
                  ? {
                      dataField: 'status',
                      editorType: 'dxSwitch',
                      label: {
                        text: t('Approve'),
                      },
                      editorOptions: {
                        onValueChanged: e => handleApprove(e),
                      },
                    }
                  : {
                      itemType: 'empty',
                      visible: false,
                    },
                {
                  itemType: 'group',
                  colSpan: 2,
                  colCount: 2,
                  items: [
                    {
                      dataField: 'loginId',
                      editorType: 'dxTextBox',
                      label: {
                        text: t('Login ID'),
                      },
                      isRequired: true,
                    },
                    {
                      dataField: '',
                      itemType: 'button',
                      horizontalAlignment: 'left',
                      buttonOptions: {
                        text: t('Duplicate check'),
                        type: 'default',
                        icon: 'check',
                        onClick: () => handleCheckDuplicate(),
                      },
                      isRequired: true,
                    },
                  ],
                },
                {
                  dataField: 'password',
                  editorType: 'dxTextBox',
                  label: {
                    text: t('Password'),
                  },
                  editorOptions: {
                    mode: viewPassword?.password ? 'text' : 'password',
                    buttons: [
                      {
                        name: 'view',
                        location: 'after',
                        options: {
                          stylingMode: 'text',
                          icon: viewPassword?.password ? eye : eyeSlash,
                          onClick: () =>
                            setViewPassword(preState => ({
                              ...preState,
                              password: !preState.password,
                            })),
                        },
                      },
                    ],
                  },
                  validationRules: [
                    passwordRequired(formData?.confirmPassword),
                    passwordValid,
                  ],
                  isRequired: isRequired,
                },
                {
                  dataField: 'confirmPassword',
                  editorType: 'dxTextBox',
                  label: {
                    text: t('Confirm Password'),
                  },
                  editorOptions: {
                    mode: viewPassword?.conPassword ? 'text' : 'password',
                    buttons: [
                      {
                        name: 'view',
                        location: 'after',
                        options: {
                          stylingMode: 'text',
                          icon: viewPassword?.conPassword ? eye : eyeSlash,
                          onClick: () =>
                            setViewPassword(preState => ({
                              ...preState,
                              conPassword: !preState.conPassword,
                            })),
                        },
                      },
                    ],
                  },
                  validationRules: [
                    passwordRequired(formData?.password),
                    passwordValid,
                    passwordMatch,
                  ],
                  isRequired: isRequired,
                },
                {
                  itemType: 'group',
                  cssClass: 'group-padding-small',
                  colCount: 3,
                  items: [
                    {
                      dataField: 'mobileCode',
                      editorType: 'dxSelectBox',
                      editorOptions: {
                        displayExpr: 'label',
                        valueExpr: 'value',
                        items: listPhone,
                      },
                      label: {
                        text: t('Mobile No'),
                      },
                      validationRules: [mobileRequired('Mobile No')],
                      isRequired: isRequired,
                    },
                    {
                      dataField: 'mobile',
                      editorType: 'dxTextBox',
                      colSpan: 2,
                      editorOptions: {
                        onKeyDown: restrictKeyboardPhone,
                      },
                      label: {
                        text: t('Mobile Number'),
                      },
                      isRequired: isRequired,
                    },
                  ],
                },
                {
                  itemType: 'group',
                  cssClass: 'group-padding-small',
                  colCount: 3,
                  items: [
                    {
                      dataField: 'phoneCode',
                      editorType: 'dxSelectBox',
                      label: {
                        text: t('Phone No'),
                      },
                      editorOptions: {
                        displayExpr: 'label',
                        valueExpr: 'value',
                        items: listPhone,
                      },
                      isRequired: true,
                    },
                    {
                      dataField: 'phone',
                      editorType: 'dxTextBox',
                      colSpan: 2,
                      label: {
                        text: t('Phone Number'),
                      },
                      editorOptions: {
                        onKeyDown: restrictKeyboardPhone,
                      },
                      isRequired: true,
                    },
                  ],
                },
                filedCompanyName(),
                [1, 2].includes(itemSelected)
                  ? {
                      dataField: 'status',
                      editorType: 'dxSwitch',
                      label: {
                        text: t('Approve'),
                      },
                      editorOptions: {
                        onValueChanged: e => handleApprove(e),
                      },
                    }
                  : {
                      itemType: 'empty',
                      visible: false,
                    },
                {
                  colSpan: 2,
                  dataField: 'note',
                  editorType: 'dxTextArea',
                  label: {
                    text: t('Note'),
                  },
                },
                {
                  colSpan: 2,
                  dataField: 'dashboard',
                  label: {
                    text: t('Dashboard permission'),
                  },
                  editorType: 'dxTextBox',
                  editorOptions: {
                    onEnterKey: () => setShowPopupByType('dashboard'),
                    showClearButton: true,
                    buttons: [
                      {
                        name: 'data1',
                        location: 'before',
                        options: {
                          icon: 'close',
                          text: formData?.formStore?.dashboard?.[0]?.name,
                          onClick: () => removeStoreDashboard('dashboard', 0),
                          visible: !!formData?.formStore?.dashboard?.[0]?.code,
                          rtlEnabled: true,
                        },
                      },
                      {
                        name: 'data2',
                        location: 'before',
                        options: {
                          icon: 'close',
                          text: formData?.formStore?.dashboard?.[1]?.name,
                          onClick: () => removeStoreDashboard('dashboard', 1),
                          visible: !!formData?.formStore?.dashboard?.[1]?.code,
                          rtlEnabled: true,
                        },
                      },
                      {
                        name: 'dataMore',
                        location: 'before',
                        options: {
                          text: `+ ${
                            formData?.formStore?.dashboard?.length - 2
                          } ${t('more')}`,
                          visible: formData?.formStore?.dashboard?.length > 2,
                        },
                      },
                      {
                        name: 'clearAll',
                        location: 'after',
                        options: {
                          stylingMode: 'text',
                          icon: 'close',
                          visible: !!formData?.formStore?.dashboard?.length,
                          onClick: () => removeStoreDashboard('dashboard', -1),
                        },
                      },
                      {
                        name: 'search',
                        location: 'after',
                        options: {
                          stylingMode: 'text',
                          icon: 'search',
                          onClick: () => setShowPopupByType('dashboard'),
                        },
                      },
                    ],
                  },
                },
                generateDxTextBox(
                  'Product type permission',
                  'productType',
                  'name',
                  { colSpan: 2 },
                ),
              ]}
              labelLocation="top"
              colCount={2}
            />
          </div>
          <div
            style={{
              padding: 20,
              backgroundColor: '#fff',
              borderRadius: 6,
              width: 400,
            }}
          >
            <TreeViewSelection
              idSelected={idSelected}
              setIdSelected={setIdSelected}
              treeViewLeftRef={treeViewLeftRef}
              treeViewRightRef={treeViewRightRef}
            />
          </div>
        </div>
      ) : (
        <>
          <Form
            formData={formData}
            ref={formRef}
            showColonAfterLabel={false}
            className="bg-white"
            items={[
              {
                dataField: 'userId',
                editorType: 'dxTextBox',
                label: {
                  text: t('ID'),
                },
                editorOptions: {
                  disabled: true,
                },
              },
              {
                dataField: 'name',
                editorType: 'dxTextBox',
                label: {
                  text: t('User Name'),
                },
                isRequired: true,
                validationRules: [
                  {
                    type: 'stringLength',
                    max: 100,
                  },
                ],
              },
              {
                dataField: 'email',
                editorType: 'dxTextBox',
                label: {
                  text: t('E-mail'),
                },
                editorOptions: {
                  mode: 'email',
                },
                isRequired: true,
                validationRules: [
                  {
                    type: 'email',
                  },
                ],
              },
              {
                dataField: 'status',
                editorType: 'dxSwitch',
                label: {
                  text: t('Approve'),
                },
                editorOptions: {
                  onValueChanged: e => handleApprove(e),
                },
              },
              {
                itemType: 'group',
                colSpan: 2,
                colCount: 2,
                items: [
                  {
                    dataField: 'loginId',
                    editorType: 'dxTextBox',
                    label: {
                      text: t('Login ID'),
                    },
                    isRequired: true,
                  },
                  {
                    dataField: '',
                    itemType: 'button',
                    horizontalAlignment: 'left',
                    buttonOptions: {
                      text: t('Duplicate check'),
                      type: 'default',
                      icon: 'check',
                      onClick: () => handleCheckDuplicate(),
                    },
                    isRequired: true,
                  },
                ],
              },
              {
                dataField: 'password',
                editorType: 'dxTextBox',
                label: {
                  text: t('Password'),
                },
                editorOptions: {
                  mode: viewPassword?.password ? 'text' : 'password',
                  buttons: [
                    {
                      name: 'view',
                      location: 'after',
                      options: {
                        stylingMode: 'text',
                        icon: viewPassword?.password ? eye : eyeSlash,
                        onClick: () =>
                          setViewPassword(preState => ({
                            ...preState,
                            password: !preState.password,
                          })),
                      },
                    },
                  ],
                },
                validationRules: [
                  passwordRequired(formData?.confirmPassword),
                  passwordValid,
                ],
                isRequired: isRequired,
              },
              {
                dataField: 'confirmPassword',
                editorType: 'dxTextBox',
                label: {
                  text: t('Confirm Password'),
                },
                editorOptions: {
                  mode: viewPassword?.conPassword ? 'text' : 'password',
                  buttons: [
                    {
                      name: 'view',
                      location: 'after',
                      options: {
                        stylingMode: 'text',
                        icon: viewPassword?.conPassword ? eye : eyeSlash,
                        onClick: () =>
                          setViewPassword(preState => ({
                            ...preState,
                            conPassword: !preState.conPassword,
                          })),
                      },
                    },
                  ],
                },
                validationRules: [
                  passwordRequired(formData?.password),
                  passwordValid,
                  passwordMatch,
                ],
                isRequired: isRequired,
              },
              {
                itemType: 'group',
                colCount: 3,
                items: [
                  {
                    dataField: 'mobileCode',
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      displayExpr: 'label',
                      valueExpr: 'value',
                      items: listPhone,
                    },
                    label: {
                      text: t('Mobile No'),
                    },
                    validationRules: [mobileRequired('Mobile No')],
                    isRequired: isRequired,
                  },
                  {
                    dataField: 'mobile',
                    editorType: 'dxTextBox',
                    colSpan: 2,
                    editorOptions: {
                      onKeyDown: restrictKeyboardPhone,
                    },
                    label: {
                      text: t('Mobile Number'),
                    },
                    isRequired: isRequired,
                  },
                ],
              },
              {
                itemType: 'group',
                colCount: 3,
                items: [
                  {
                    dataField: 'phoneCode',
                    editorType: 'dxSelectBox',
                    label: {
                      text: t('Phone No'),
                    },
                    editorOptions: {
                      displayExpr: 'label',
                      valueExpr: 'value',
                      items: listPhone,
                    },
                    isRequired: true,
                  },
                  {
                    dataField: 'phone',
                    editorType: 'dxTextBox',
                    colSpan: 2,
                    label: {
                      text: t('Phone Number'),
                    },
                    editorOptions: {
                      onKeyDown: restrictKeyboardPhone,
                    },
                    isRequired: true,
                  },
                ],
              },
              filedCompanyName(),
              filedVendor(),

              {
                colSpan: 2,
                dataField: 'note',
                editorType: 'dxTextArea',
                label: {
                  text: t('Note'),
                },
              },
              {
                dataField: 'dashboard',
                label: {
                  text: t('Dashboard permission'),
                },
                editorType: 'dxTextBox',
                editorOptions: {
                  onEnterKey: () => setShowPopupByType('dashboard'),
                  showClearButton: true,
                  buttons: [
                    {
                      name: 'data1',
                      location: 'before',
                      options: {
                        icon: 'close',
                        text: formData?.formStore?.dashboard?.[0]?.name,
                        onClick: () => removeStoreDashboard('dashboard', 0),
                        visible: !!formData?.formStore?.dashboard?.[0]?.code,
                        rtlEnabled: true,
                      },
                    },
                    {
                      name: 'data2',
                      location: 'before',
                      options: {
                        icon: 'close',
                        text: formData?.formStore?.dashboard?.[1]?.name,
                        onClick: () => removeStoreDashboard('dashboard', 1),
                        visible: !!formData?.formStore?.dashboard?.[1]?.code,
                        rtlEnabled: true,
                      },
                    },
                    {
                      name: 'dataMore',
                      location: 'before',
                      options: {
                        text: `+ ${
                          formData?.formStore?.dashboard?.length - 2
                        } ${t('more')}`,
                        visible: formData?.formStore?.dashboard?.length > 2,
                      },
                    },
                    {
                      name: 'clearAll',
                      location: 'after',
                      options: {
                        stylingMode: 'text',
                        icon: 'close',
                        visible: !!formData?.formStore?.dashboard?.length,
                        onClick: () => removeStoreDashboard('dashboard', -1),
                      },
                    },
                    {
                      name: 'search',
                      location: 'after',
                      options: {
                        stylingMode: 'text',
                        icon: 'search',
                        onClick: () => setShowPopupByType('dashboard'),
                      },
                    },
                  ],
                },
              },
            ]}
            labelLocation="top"
            colCount={2}
          />
          <div style={{ textAlign: 'left', margin: '20px 0 50px' }}>
            <Button
              text={t('Save')}
              type="normal"
              icon="save"
              stylingMode="contained"
              onClick={() => handleSubmit()}
              style={{ marginRight: 10 }}
            />
            <Button
              text={t('Cancel')}
              type="normal"
              stylingMode="contained"
              icon="close"
              onClick={() => setModeView({ type: 'list' })}
            />
          </div>
          <TreeViewSelection
            idSelected={idSelected}
            setIdSelected={setIdSelected}
            treeViewLeftRef={treeViewLeftRef}
            treeViewRightRef={treeViewRightRef}
          />
        </>
      )}

      {getPopupByType(showPopupByType)}
      <PopupConfirm
        visible={showModalConfirm}
        content={contentPopupConfirm}
        onOk={handleConfirm}
        onHiding={() => setShowModalConfirm(false)}
        onHidingCallback={() => handleClose()}
      />
    </div>
  );
};

export default FormCreate;
